import type { FC, ReactChild } from 'react';
import React from 'react';

import type { IEditorQuery } from './../ricos-content-query';

type EditorQueryContextProps = {
  editorQuery: IEditorQuery;
  children: ReactChild;
};

export const EditorQueryContext = React.createContext<IEditorQuery>(
  null as unknown as IEditorQuery
);

export const EditorQueryContextProvider: FC<EditorQueryContextProps> = ({
  editorQuery,
  children,
}) => <EditorQueryContext.Provider value={editorQuery}>{children}</EditorQueryContext.Provider>;
